import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        margin: toRems([100, 0])
    },

    '& .infoText': {
        maxWidth: 800,
        marginBottom: toRem(30),

        '.title': {
            marginBottom: toRem(10),
            fontSize: toRem(24),
            color: theme.colors.goldDark,
            [theme.breakpoints.up('md')]: {
                marginBottom: toRem(30),
                fontSize: toRem(35)
            }
        }
    },
    '& .infoList': {
        listStyle: 'none',
        marginBottom: toRem(80),
        maxWidth: 1150,

        '&-wrapper': {
            [theme.breakpoints.up('1150')]: {
                display: 'grid',
                gridTemplateColumns: '3fr 1fr',
                gridGap: 30,
                justifyContent: 'space-between',
                marginBottom: toRem(120)
            },

            p: {
                fontSize: toRem(14),
                lineHeight: 1.75,
                marginBottom: toRem(20),

                [theme.breakpoints.up('md')]: {
                    fontSize: toRem(16)
                }
            }
        },

        li: {
            paddingBottom: toRem(35)
        },

        'li:not(:first-of-type)': {
            marginBottom: toRem(20),
            paddingTop: toRem(30)
        },

        'li:not(:last-of-type)': {
            borderBottom: '1px solid #FFFFFF4D'
        },

        [theme.breakpoints.down('md')]: {
            li: {
                paddingBottom: toRem(28)
            },

            'li:first-of-type': {
                paddingTop: toRem(20),
                borderTop: '1px solid #FFFFFF4D'
            },

            'li:last-of-type': {
                paddingTop: 0,
                borderBottom: '1px solid #FFFFFF4D'
            }
        },

        a: {
            color: theme.colors.goldLight
        },

        '.info-title': {
            marginBottom: toRem(10),
            textTransform: 'uppercase',
            color: theme.colors.goldDark,
            fontSize: toRem(18),
            display: 'block',

            [theme.breakpoints.up('md')]: {
                fontSize: toRem(20)
            }
        },

        '.info-value': {
            margin: 0,
            fontSize: toRem(16),
            lineHeight: 1.75,

            [theme.breakpoints.down('md')]: {
                fontSize: toRem(14)
            }
        }
    }
})

export default style
